// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationResponse } from './priorAuthorizationResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': PriorAuthorizationResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PriorAuthorizationResponse"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationDefaultResponse.attributeTypeMap;
    }
}
